
import { Component, Vue } from 'vue-property-decorator';
import { adminStore, mainStore, leadTimeStore, userToolStore, leadStore } from '@/utils/store-accessor';
import _ from 'lodash';

@Component({
  components: {},
})
export default class TimesList extends Vue {
  public filterDeparture = 0;
  public filterRole = 0;
  public isLoading = true;
  public isAddingNew = false;
  public isUpdating = false;
  public agendadorAdd: any = 0;
  public vendedorAdd: any = 0;
  public id: any = null;
  public headers = [
    {
      text: 'Atualizado em',
      value: 'updated_at',
      align: 'left',
    },
    {
      text: 'Agendador',
      value: 'agen_full_name',
      align: 'left',
    },
    {
      text: 'E-mail (Agendador)',
      value: 'agen_email',
      align: 'left',
    },
    // {
    //   text: "Telefone (Agendador)",
    //   value: "agen_telefone",
    //   align: "left",
    // },
    {
      text: 'Vendedor',
      value: 'vend_full_name',
      align: 'left',
    },
    {
      text: 'E-mail (Vendedor)',
      value: 'vend_email',
      align: 'left',
    },
    // {
    //   text: "Telefone (Vendedor)",
    //   value: "vend_telefone",
    //   align: "left",
    // },
    {
      text: 'Ações',
      value: 'actions',
      align: 'left',
    },
  ];

  get leadTimes() {
    return leadTimeStore.leadTimes;
  }

  get currentUser() {
    return mainStore.userProfile;
  }

  get agendadores() {
    return _.orderBy(leadStore.agendadores, ['user.franchising_id', 'user.full_name']);
  }

  get vendedores() {
    return _.orderBy(leadStore.vendedores, ['user.franchising_id', 'user.full_name']);
  }

  get leadTimeTool() {
    return userToolStore.currentUserTools.find((t) => t.tool_id === 42);
  }

  get users() {
    return _.orderBy(
      _.filter(adminStore.users, (u) => _.includes([1, 1069], u.franchising_id) && u.full_name && u.is_active),
      'full_name'
    );
  }

  public async addLeadTime() {
    if (!this.id) {
      // CREATE
      if (this.agendadorAdd && this.vendedorAdd) {
        await leadTimeStore.addLeadTimes({
          agendador_id: this.agendadorAdd,
          vendedor_id: this.vendedorAdd,
          franchising_id: this.currentUser!.franchising_id,
        });
        await leadTimeStore.getLeadTimes();
        this.isAddingNew = false;
      }
    } else {
      // UPDATE
      if (this.agendadorAdd && this.vendedorAdd) {
        await leadTimeStore.updateLeadTimes({
          id: this.id,
          agendador_id: this.agendadorAdd,
          vendedor_id: this.vendedorAdd,
          franchising_id: this.currentUser!.franchising_id,
        });
        await leadTimeStore.getLeadTimes();
        this.isUpdating = false;
      }
    }

    this.agendadorAdd = {};
    this.vendedorAdd = {};
  }

  public async updateLeadTime(time) {
    this.id = time.id;
    this.isUpdating = true;
    this.agendadorAdd = time.agendador_id;
    this.vendedorAdd = time.vendedor_id;
  }

  public async removeLeadTime(id: number) {
    this.$swal({
      title: 'Confirmar exclusão do time?',
      icon: 'warning',
      text: 'O time será apagado',
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        await leadTimeStore.removeLeadTimes(id);
        await leadTimeStore.getLeadTimes();
      }
    });
  }

  public async mounted() {
    // await mainStore.getUserProfile();

    await leadStore.getAgendadoresVendedores();
    await leadTimeStore.getLeadTimes();
    this.isLoading = false;
  }
}
